import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
// @material-ui/core components
import {
  LinearProgress,
  TextField,
  Checkbox,
  FormControlLabel,
  Tabs,
  Tab,
  Button,
  CircularProgress,
} from "@material-ui/core";
// @material-ui/styles
import styles from "../../../assets/jss/layouts/appStyle";
import { makeStyles } from "@material-ui/core/styles";
// core components
import { GradingSchemaRepository } from "./GradingSchemaRepository";
import VacancyConfigComponent from "../vacancyApplicationConfig/VacancyConfigComponent";
import { validateGradingSchemaCreateForm } from "./GradingSchemaValidations";
import { LOCALE } from "../../../properties/Locale";
import EntityMetadata from "../../../common/components/EntityMetadata";
import {
  notifyShowSuccessMessage,
  notifyShowErrorMessage,
  triggerRerender,
} from "../../../common/actions/CommonActions";
import Card from "../../../common/components/Card/Card.js";
import CardHeader from "../../../common/components/Card/CardHeader.js";
import CardBody from "../../../common/components/Card/CardBody.js";

const useStyles = makeStyles(styles);

export default function GradingSchemaEditComponent(props) {
  const classes = useStyles();
  const [gradingSchemaId] = useState(props.match.params.gradingSchemaId);
  const [tabIndex, setTabIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [redirectTo, setRedirectTo] = useState();
  const [btnSubmitLoading, setBtnSubmitLoading] = useState(true);
  const [isActive, setIsActive] = useState();
  const {
    handleSubmit: editGradingSchemaForm,
    register: registerEditForm,
    errors: errorsEditGradingSchema,
    setValue,
    getValues,
    control,
  } = useForm(
    {
      validationSchema: validateGradingSchemaCreateForm,
    },
    {
      defaultValues: { locked: false },
    }
  );
  const dispatch = useDispatch();

  useEffect(() => {
    loadGradingSchema(gradingSchemaId);
  }, []);

  const onEditGradingSchema = (values) => {
    showLoadingBar();
    GradingSchemaRepository.updateGradingSchema(values)
      .then((res) => {
        hideLoadingBar();
        dispatch(triggerRerender());
        dispatch(
          notifyShowSuccessMessage(LOCALE.grading_schema_update_success_message)
        );
        setRedirectTo("/app/configuration/gradingSchema");
      })
      .catch((err) => {
        hideLoadingBar();
        dispatch(notifyShowErrorMessage(err.message));
      });
  };

  const loadGradingSchema = (id) => {
    showLoadingBar();
    GradingSchemaRepository.fetchGradingSchema(id).then((res) => {
      Object.keys(res.data).map(function (item) {
        if (Object.keys(getValues()).indexOf(item) === -1) {
          registerEditForm({ name: item, type: "custom" });
        }
      });
      Object.entries(res.data).map(function (item) {
        setValue(item[0], item[1]);
      });
      hideLoadingBar();
    });
  };

  const showLoadingBar = () => {
    setLoading(true);
    setBtnSubmitLoading(true);
  };

  const hideLoadingBar = () => {
    setLoading(false);
    setBtnSubmitLoading(false);
  };

  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };

  return (
    <div>
      {redirectTo && <Redirect to={redirectTo} />}
      <Card>
        <CardHeader color="theme">
          <h4 className={classes.cardTitleWhite}>
            {`${LOCALE.grading_schema_edit}${
              getValues("name") ? ": " + getValues("name") : ""
            }`}
          </h4>
        </CardHeader>
        <CardBody>
          {loading ? <LinearProgress color="secondary" /> : ""}
          <div>
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label={LOCALE.grading_schema_basic_info} />
              <Tab label={LOCALE.grading_schema_config} />
            </Tabs>
            {tabIndex === 0 && (
              <form onSubmit={editGradingSchemaForm(onEditGradingSchema)}>
                <TextField
                  id="name"
                  label={LOCALE.grading_schema_name}
                  error={errorsEditGradingSchema?.name}
                  helperText={errorsEditGradingSchema?.name?.message}
                  fullWidth={true}
                  size="small"
                  name="name"
                  margin="normal"
                  variant="outlined"
                  inputRef={registerEditForm}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    disabled: btnSubmitLoading,
                    shrink: true,
                  }}
                />

                <FormControlLabel
                  control={
                    <Controller
                      as={<Checkbox />}
                      control={control}
                      name="locked"
                    />
                  }
                  label={LOCALE.grading_schema_locked}
                />

                <EntityMetadata data={getValues()} />
                <div style={{ paddingTop: "10px" }}>
                  <Button
                    style={{ marginRight: "5px", float: "right" }}
                    type="submit"
                    size="small"
                    variant="contained"
                    disabled={btnSubmitLoading}
                    className={btnSubmitLoading ? "btn-loading" : ""}
                    color="primary"
                  >
                    {LOCALE.save}
                    {btnSubmitLoading && (
                      <CircularProgress
                        color="secondary"
                        size={20}
                        style={{ position: "absolute" }}
                      />
                    )}
                  </Button>
                  <Link
                    to={`/app/configuration/gradingSchema`}
                    style={{ textDecoration: "none" }}
                  >
                    <Button
                      style={{ marginRight: "5px", float: "right" }}
                      color="secondary"
                      variant="outlined"
                      size="small"
                    >
                      {LOCALE.back}
                    </Button>
                  </Link>
                </div>
              </form>
            )}
            {tabIndex === 1 && (
              <VacancyConfigComponent gradingSchemaId={gradingSchemaId} />
            )}
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
